import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    label: _ctx.field.label,
    prop: _ctx.field.prop,
    rules: _ctx.field.rule
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        type: "textarea",
        modelValue: _ctx.innerValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
        autosize: {minRows: 5,maxRows: 10},
        placeholder: '请输入' + _ctx.field.label,
        disabled: _ctx.field.disabled,
        maxlength: _ctx.maxLength,
        "show-word-limit": ""
      }, null, 8, ["modelValue", "placeholder", "disabled", "maxlength"])
    ]),
    _: 1
  }, 8, ["label", "prop", "rules"]))
}